"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContext = void 0;
var react_1 = require("react");
exports.FormContext = react_1.createContext(undefined);
